import { useDebounce } from "@react-hook/debounce";
import React from "react";
import { useEffect } from "react";
import { useState } from "react";

type MenuProps = {
  placeholder?: string;
  value?: string;
  onSearch: Function;
};

const MenuSearch = ({
  onSearch,
  placeholder = "Search Accounts",
  value,
}: MenuProps) => {
  const [text, setText] = useState<string | undefined>(value);
  const [searchTerm, setSearchTerm] = useDebounce<string | undefined>(
    value,
    500
  );

  useEffect(() => {
    onSearch(searchTerm);
  }, [searchTerm]);

  const doSearch = (str: string) => {
    setText(str);
    setSearchTerm(str);
  };

  return (
    <div className='ui aligned category search item'>
      <div className='ui transparent icon input'>
        <input
          value={text ? text : ""}
          autoFocus
          className='prompt'
          placeholder={placeholder}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            doSearch(e.currentTarget.value)
          }
        />
        <i className='search link icon' />
      </div>
    </div>
  );
};

export default MenuSearch;
